import { SSNNormalizer, taxIdNormalizer } from "validators";

export const getMappedMerchantInfoData = data => {
	const applicationId = data?.application_id;
	const processor = data?.processor;

	const navInfo = {
		mid: data?.mid,
		dbaName: data?.dba_name,
		priorityType: data?.priority_type,
		merchantId: data?.merchant_id,
		reviewType: data?.review_type,
	};

	const underwriting = {
		underwritingDecision: data?.underwriting_decision,
		underwritingApprovedAt: data?.underwriting_approved_at,
		avgMonthlyProfit: data?.avg_monthly_profit,
	};

	const dba = {
		legalName: data?.legal_name,
		businessEstablishedDate: data?.business_established_date,
		dbaBusinessAddress: data?.business_address,
		ecommerceCardAcceptance: data?.ecommerce_card_acceptance,
		swipedCardAcceptance: data?.swiped_card_acceptance,
		keyedCardAcceptance: data?.keyed_card_acceptance,
		legalAddress: data?.legal_address,
		acceptedCardPreviously: data?.accepted_cards_previously,
		businessPhone: data?.business_phone,
		previousProcessor: data?.previous_processor_name,
		mccCode: data?.mcc_code,
		mccCodeDescription: data?.mcc_code_description,
		website: data?.website,
		detailedExplanationWhatDoYouSell:
			data?.detailed_explanation_what_do_you_sell,
		processor: data?.processor,
		typeOfBusiness: data?.type_of_business,
		sponsor: data?.sponsor,
		federalTaxID: taxIdNormalizer(data?.tax_id),
		creditExposure: data?.credit_exposure,
	};

	const owners = {
		owner1: {
			applicationId: data?.application_id,
			underwritingDecision: data?.underwriting_decision,
			ownerId: data?.owner_1?.id,
			firstName: data?.owner_1?.first_name,
			lastName: data?.owner_1?.last_name,
			ssn: SSNNormalizer(data?.owner_1?.ssn),
		},
		owner2: {
			applicationId: data?.application_id,
			underwritingDecision: data?.underwriting_decision,
			ownerId: data?.owner_2?.id,
			firstName: data?.owner_2?.first_name,
			lastName: data?.owner_2?.last_name,
			ssn: SSNNormalizer(data?.owner_2?.ssn),
		},
		owner3: {
			applicationId: data?.application_id,
			underwritingDecision: data?.underwriting_decision,
			ownerId: data?.owner_3?.id,
			firstName: data?.owner_3?.first_name,
			lastName: data?.owner_3?.last_name,
			ssn: SSNNormalizer(data?.owner_3?.ssn),
		},
		owner4: {
			applicationId: data?.application_id,
			underwritingDecision: data?.underwriting_decision,
			ownerId: data?.owner_4?.id,
			firstName: data?.owner_4?.first_name,
			lastName: data?.owner_4?.last_name,
			ssn: SSNNormalizer(data?.owner_4?.ssn),
		},
	};

	const desiredLimits = {
		vmcdMonthly: data?.vmcd_monthly,
		vmcdAvgTicket: data?.vmcd_avg_ticket,
		vmcdHighTicket: data?.vmcd_high_ticket,
		amexMonthly: data?.amex_monthly,
		amexAvgTicket: data?.amex_avg_ticket,
		amexHighTicket: data?.amex_high_ticket,
		fundingType: data?.funding_type,
		isDailyDiscount: data?.is_daily_discount,
	};

	const fees = {
		feeProgram: data?.fee_program,
		interchangePlusAmexFee: data?.interchange_plus_amex_fee,
		interchangePlusVmcdFee: data?.interchange_plus_vmcd_fee,
		interchangePlusOfflineDebitFee:
			data?.interchange_plus_offline_debit_fee,
		flatRateFee: data?.flat_rate_fee,
		threeTierQualVmcdFee: data?.three_tier_qual_vmcd_fee,
		threeTierMidQualVmcdFee: data?.three_tier_mid_qual_vmcd_fee,
		threeTierNonQualVmcdFee: data?.three_tier_non_qual_vmcd_fee,
		threeTierQualAmexFee: data?.three_tier_qual_amex_fee,
		threeTierMidQualAmexFee: data?.three_tier_mid_qual_amex_fee,
		threeTierNonQualAmexFee: data?.three_tier_non_qual_amex_fee,
		threeTierQualOfflineDebitFee: data?.three_tier_qual_offline_debit_fee,
		threeTierMidQualOfflineDebitFee:
			data?.three_tier_mid_qual_offline_debit_fee,
		threeTierNonQualOfflineDebitFee:
			data?.three_tier_non_qual_offline_debit_fee,
		errQualVmcdFee: data?.err_qual_vmcd_fee,
		errNonQualVmcdFee: data?.err_non_qual_vmcd_fee,
		errQualAmexFee: data?.err_qual_amex_fee,
		errNonQualAmexFee: data?.err_non_qual_amex_fee,
		errQualOfflineDebitFee: data?.err_qual_offline_debit_fee,
		errNonQualOfflineDebitFee: data?.err_non_qual_offline_debit_fee,
		dualFlatRateCardPresentFee: data?.dual_flat_rate_card_present,
		dualFlatRateCardPresentAuthFee:
			data?.dual_flat_rate_card_present_auth_fee,
		dualFlatRateCardNotPresentFee: data?.dual_flat_rate_card_not_present,
		dualFlatRateCardNotPresentAuthFee:
			data?.dual_flat_rate_card_not_present_auth_fee,
	};

	const agentSubHeader = {
		agentName: data?.primary_agent_name,
		auroraProfit: data?.aurora_profit,
		underwritingApprovedAt: data?.underwriting_approved_at,
		bank: data?.sponsor,
		fees,
	};

	return {
		applicationId,
		processor,
		navInfo,
		underwriting,
		dba,
		owners,
		desiredLimits,
		fees,
		agentSubHeader,
	};
};
